import React, { useState } from "react"

const ClientFilter = ({
  emp_options,
  practice_options,
  status_options,
  all_clients,
  settable_data,
  setVisible,
}) => {
  const [filters, setFilters] = useState({
    employee: "",
    assistant: "",
    status: "",
    practice: "",
  })

  const handleFilterChange = e => {
    const { name, value } = e.target
    setFilters({
      ...filters,
      [name]: value,
    })
  }

  const handleClearFilters = () => {
    setFilters({
      employee: "",
      assistant: "",
      status: "",
      practice: "",
    })

    settable_data(all_clients)
    setVisible(false)
  }

  const handleFilterSubmit = () => {
    const { practice, employee, status, assistant } = filters

    const filteredClients = all_clients.filter(client => {
      let isValid = true

      // Filter by practice
      if (practice && client.clientUnderPractice?.id != parseInt(practice)) {
        isValid = false
      }

      // Filter by Status
      if (status && client.clientStatus?.id != parseInt(status)) {
        isValid = false
      }

      // Filter by Assistant
      if (assistant && client.assistant?.id != parseInt(assistant)) {
        isValid = false
      }

      // Filter by Employee
      if (employee && !checkEmpExist(client, employee)) isValid = false

      return isValid
    })

    settable_data(filteredClients)
    setVisible(false)
  }

  const checkEmpExist = (currData, currEmp) => {
    const empTypes = [
      "clientManager",
      "productionManager",
      "administrator",
      "assistant",
    ]
    return empTypes.some(emp => currData[emp]?.id == currEmp)
  }

  const assistantOptions = emp_options?.filter(e => e?.isAssistant)

  return (
    <div>
      <div className="row align-items-end justify-content-end mb-4 border-bottom border-primary pb-4 ">
        {emp_options.length ? (
          <div className="col-md-3">
            <label htmlFor="">Employee</label>
            <select
              className="form-select"
              name="employee"
              value={filters.employee}
              onChange={handleFilterChange}
            >
              <option value="">All Employees</option>
              {emp_options
                ?.slice()
                .sort((a, b) =>
                  `${a.name} ${a.lastName}`.localeCompare(
                    `${b.name} ${b.lastName}`
                  )
                )
                .map(s => (
                  <option
                    key={s.id}
                    value={s.id}
                  >{`${s.name} ${s.lastName}`}</option>
                ))}
            </select>
          </div>
        ) : null}

        {assistantOptions.length ? (
          <div className="col-md-3">
            <label htmlFor="">Assistant</label>
            <select
              className="form-select"
              name="assistant"
              value={filters.assistant}
              onChange={handleFilterChange}
            >
              <option value="">All Assistant</option>
              {assistantOptions
                ?.slice()
                .sort((a, b) =>
                  `${a.name} ${a.lastName}`.localeCompare(
                    `${b.name} ${b.lastName}`
                  )
                )
                .map(s => (
                  <option
                    key={s.id}
                    value={s.id}
                  >{`${s.name} ${s.lastName}`}</option>
                ))}
            </select>
          </div>
        ) : null}

        {practice_options.length ? (
          <div className="col-md-3">
            <label htmlFor="">Practices</label>
            <select
              className="form-select"
              name="practice"
              value={filters.practice}
              onChange={handleFilterChange}
            >
              <option value="">All Practices</option>
              {practice_options
                ?.slice()
                .sort((a, b) => a.practiceName.localeCompare(b.practiceName))
                .map(s => (
                  <option key={s.id} value={s.id}>
                    {s.practiceName}
                  </option>
                ))}
            </select>
          </div>
        ) : null}

        {status_options.length ? (
          <div className="col-md-3">
            <label htmlFor="">Client Status</label>
            <select
              className="form-select"
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">All Status</option>
              {status_options
                ?.slice()
                .sort((a, b) => a.statusName.localeCompare(b.statusName))
                .map(s => (
                  <option key={s.id} value={s.id}>
                    {s.statusName}
                  </option>
                ))}
            </select>
          </div>
        ) : null}

        <div className="col-md-3 mt-4 text-end">
          <button className="btn btn-primary " onClick={handleFilterSubmit}>
            <i className="fas fa-filter me-1"></i> Filter
          </button>

          <button className="btn btn-danger  ms-2" onClick={handleClearFilters}>
            <i className="fas fa-times me-1"></i> Clear
          </button>
        </div>
      </div>
    </div>
  )
}

export default ClientFilter
